import type { Action } from 'state/actions';
import { removeElements } from 'state/utils/array';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { OrdersBasketWorkspaceTabContentState } from './tabContent.model';
import { initialOrdersBasketWorkspaceTabContentState } from './tabContent.model';

export function ordersBasketWorkspaceTabContentReducer(
  state: OrdersBasketWorkspaceTabContentState = initialOrdersBasketWorkspaceTabContentState,
  action: Action,
): OrdersBasketWorkspaceTabContentState {
  switch (action.type) {
    case 'WORKSPACE_TAB_CREATED':
      if (action.workspace !== 'ordersBasket') {
        return state;
      }
      return addOrReplaceKey(state, action.id, {
        tabId: action.id,
        workspace: action.workspace,
        isFetchingTabContent: false,
        formIds: [],
      });
    case 'WORKSPACE_TAB_REMOVED':
      if (action.workspace !== 'ordersBasket') {
        return state;
      }
      return removeKey(state, action.id);
    case 'ORDERS_BASKET_TAB_CONTENT_INITIALIZED':
      return patchKey(state, action.tabId, () => ({
        wrapperType: action.wrapperType,
        productType: action.productType,
        productSubtype: action.productSubtype,
      }));
    case 'NEW_ORDERS_BASKET_FORM_REQUESTED':
    case 'ORDERS_BASKET_IMPORT_REQUESTED':
    case 'ORDERS_BASKET_INIT_FORM_REQUESTED':
      return patchKey(state, action.tabId, previousState => ({
        formIds: [...previousState.formIds, action.temporaryNegotiationId],
      }));
    case 'ORDERS_BASKET_BATCH_WORKSPACE_FORM_INITIALIZED':
      return patchKey(state, action.tabId, previousState => ({
        formIds: previousState.formIds
          .map(id => (id === action.temporaryNegotiationId ? action.form.negotiationId : id))
          .filter((id): id is string => id !== undefined),
      }));
    case 'ORDERS_BASKET_IMPORT_RECEIVED':
      return patchKey(state, action.tabId, previousState => ({
        formIds: [...previousState.formIds.filter(id => id !== action.temporaryNegotiationId), action.negotiationId],
      }));
    case 'ORDERS_BASKET_IMPORT_WRONG_PRODUCT_RECEIVED':
    case 'ORDERS_BASKET_IMPORT_FAILED':
    case 'ORDERS_BASKET_INIT_FORM_FAILED':
      return patchKey(state, action.tabId, previousState => ({
        formIds: [...previousState.formIds.filter(id => id !== action.temporaryNegotiationId)],
      }));
    case 'ORDERS_BASKET_FORM_DELETED':
      return patchKey(state, action.tabId, previousState => ({
        formIds: removeElements(previousState.formIds, action.formId),
      }));
    case 'ORDERS_BASKET_TAB_CONTENT_FETCH_REQUESTED':
      return addOrReplaceKey(state, action.tabId, {
        tabId: action.tabId,
        workspace: 'ordersBasket',
        formIds: [],
        isFetchingTabContent: true,
      });
    case 'ORDERS_BASKET_TAB_CONTENT_FETCHED':
      return patchKey(state, action.tabId, () => ({
        workspace: action.tabContent.workspace,
        formIds: action.tabContent.negotiationIds,
        wrapperType: action.tabContent.wrapperType,
        productSubtype: action.tabContent.productSubtype,
        productType: action.tabContent.productType,
        isFetchingTabContent: false,
      }));
    case 'ORDERS_BASKET_TAB_CONTENT_FETCH_FAILED':
      return patchKey(state, action.tabId, () => ({
        isFetchingTabContent: false,
      }));
    default:
      return state;
  }
}
